<template>
  <div
    v-for="eventType in props.cardData.eventTypes"
    :key="eventType.name"
    class="alerts-container"
  >
    <div
      v-if="
        eventType.type === 'directPush' ||
        eventType.type === 'broadcast' ||
        eventType.type === 'priceChange'
      "
      class="eventTypeRow"
    >
      <EventRow :config="eventType" :inputs="props.inputs ?? {}" />
    </div>
    <div v-else-if="eventType.type === 'label'" class="eventTypeRow">
      <label class="eventLabel">
        {{ eventType.name }}
      </label>
    </div>
    <div v-else>
      <EventTypeUnsuppportedRow />
    </div>
  </div>
</template>

<script setup lang="ts">
import { SupportedCardConfigType } from '@notifi-network/notifi-frontend-client';
import { EventRow, EventTypeUnsuppportedRow } from '../../components';

const props = defineProps<{
  cardData: SupportedCardConfigType;
  inputs?: Record<string, string | undefined>;
}>();
</script>

<style lang="scss" scoped>
.alerts-container {
  padding: 0px 24px 0px 24px;
}
.eventTypeRow {
  margin-bottom: 16px;
}

.eventLabel {
  letter-spacing: 0.01em;
  font-family: Arial;
  opacity: 0.6;
  font-size: 12px;
  font-weight: 700;
}
</style>
